// src/pages/DetalhesDisciplina.jsx

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../styles/CadastroCliente.css"; 
import "../styles/global.css"; 

const DetalhesDisciplina = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [disciplina, setDisciplina] = useState(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    const buscarDisciplina = async () => {
      try {
        const response = await fetch(`http://localhost:5000/api/disciplinas/${id}`);
        const data = await response.json();

        if (response.ok) {
          setDisciplina(data);
        } else {
          alert("Disciplina não encontrada.");
          navigate("/disciplinas");
        }
      } catch (error) {
        console.error("Erro ao buscar disciplina:", error);
        alert("Erro ao carregar os dados.");
        navigate("/disciplinas");
      } finally {
        setCarregando(false);
      }
    };

    buscarDisciplina();
  }, [id, navigate]);

  const handleExcluir = async () => {
    if (!window.confirm("Deseja realmente excluir esta disciplina?")) return;

    try {
      const usuario_id = localStorage.getItem("user_id");
      const response = await fetch(`http://localhost:5000/api/disciplinas/${id}?usuario_id=${usuario_id}`, {
        method: "DELETE",
      });
      

      if (response.ok) {
        alert("Disciplina excluída com sucesso.");
        navigate("/disciplinas");
      } else {
        alert("Erro ao excluir disciplina.");
      }
    } catch (error) {
      console.error("Erro ao excluir disciplina:", error);
      alert("Erro de conexão.");
    }
  };

  if (carregando || !disciplina) return <p>Carregando dados da disciplina...</p>;

  return (
    <div className="form-wrapper">
      <h2 className="form-title">Detalhes da Disciplina</h2>

      <div className="form-actions">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => navigate("/disciplinas")}
        >
          Voltar
        </button>

        <button
          type="button"
          className="btn btn-primary"
          onClick={() => navigate(`/editar-disciplina/${id}`)}
        >
          Editar
        </button>

        <button
          type="button"
          className="btn btn-danger"
          onClick={handleExcluir}
        >
          Excluir
        </button>
      </div>

      <div className="form-row">
        <div className="form-group" style={{ width: '250px', flex: 'none' }}>
          <label>Código</label>
          <input
            name="codigo"
            type="text"
            value={disciplina.codigo || ""}
            disabled
          />
        </div>
        <div className="form-group">
          <label>Nome</label>
          <input
            name="nome"
            type="text"
            value={disciplina.nome || ""}
            disabled
          />
        </div>
      </div>

      <div className="form-group form-group-full">
        <label>Ementa</label>
        <textarea    
          name="ementa"
          rows="6"
          value={disciplina.ementa || ""}
          disabled
          style={{
            resize: "vertical",
            fontSize: "0.7rem",
            fontFamily: "Arial, sans-serif",
            padding: "8px",
          }}
        />
      </div>
    </div>
  );
};

export default DetalhesDisciplina;
